import ZodFormProvider from '@/global/components/ZodFormProvider'
import { cn } from '@/lib/utils'
import logo from 'assets/logo.svg'
import textoLogo from 'assets/ponto-agil-texto.svg'
import { useAuth } from 'hooks'
import { useFormContext } from 'react-hook-form'
import { Outlet } from 'react-router-dom'
import { LoginSchema, planos as planosApi } from 'service/api'
import { LoginForm } from 'templates/Auth'
import { z } from 'zod'
import { ToggleTheme } from '../global/components/ToggleTheme'

export function Login() {
    const { data: planos } = planosApi.useFetch({
        enabled: window.location.pathname !== '/',
        refetchOnWindowFocus: false,
    })

    return (
        <div className="h-[calc(100vh-4rem)] flex flex-col w-full overflow-clip">
            <div className="ml-auto flex flex-end p-4">
                <ToggleTheme />
            </div>
            <div className="flex flex-col my-auto gap-2 items-center">
                <div
                    className={cn(
                        'flex items-center justify-center gap-4 mb-4 w-96',
                        'dark:invert',
                    )}
                >
                    <div className="size-16 aspect-1/1">
                        <img
                            src={logo}
                            alt="logo"
                            loading="lazy"
                            className={cn(
                                'size-full',
                                'filter-[invert(11%)_sepia(42%)_saturate(2894%)_hue-rotate(213deg)_brightness(95%)_contrast(97%)]',
                                'dark:filter-none',
                            )}
                        />
                    </div>
                    <div className="h-16 w-auto">
                        <img
                            src={textoLogo}
                            alt="PONTO ÁGIL"
                            loading="lazy"
                            className={cn(
                                'size-full',
                                'filter-[invert(11%)_sepia(42%)_saturate(2894%)_hue-rotate(213deg)_brightness(95%)_contrast(97%)]',
                                'dark:filter-none',
                            )}
                        />
                    </div>
                </div>
                <div
                    className={cn(
                        'flex-1 max-w-sm mx-auto flex flex-col rounded-md p-4',
                        'shadow-md bg-card',
                    )}
                >
                    <ZodFormProvider schema={LoginSchema}>
                        <span className="text-2xl text-primary uppercase text-center pb-4 pt-2">
                            Bem vindo
                        </span>
                        <Form />
                    </ZodFormProvider>
                </div>
            </div>
            <Outlet context={{ planos }} />
        </div>
    )
}

function Form() {
    const { handleSubmit } = useFormContext<z.infer<typeof LoginSchema>>()
    const { handleLogin } = useAuth()

    return (
        <form onSubmit={handleSubmit(data => handleLogin(data))}>
            <LoginForm />
        </form>
    )
}
